<template>
  <div class="comp-ly-list-layout">
    <template v-if="!skeletonLoading">
      <div v-show="selectTableIds?.length" class="list-batch-wrap">
        <ly-list-batch-buttons :listFields="data.fieldList" :entityId="entity" :filterParams="filterParams" :buttonShortcut="buttonShortcut" :fieldsListAll="buttonBatch" @cb="resetSelected" :selectIds="selectTableIds" :bingDataList="bingDataList" :viewId="data.viewId" :tProps="tProps"></ly-list-batch-buttons>
      </div>
      <div v-show="!selectTableIds?.length" class="filter-wrap-layout">
        <ly-list-universal-buttons :entityId="entity" :universalButtonParams="universalButtonParams" ref="lyListUniversalButtonsRef" @cb="universalRefreshList"></ly-list-universal-buttons>
        <div class="title-split" v-if="props.isFilter">
          <ly-advanced-filter v-if="isShowFilter" :entity="entity" :viewId="data.viewId" :dataPermission="data.dataPermission" :fieldList="data.fieldList" :commonList="highConditionsList" :dropdownFieldList="fieldFilterList" :fieldGroups="fieldGroups" :key="data.viewId" @cb="getSearchData" :newConditionCount="data.ruleForm.conditions?.length" @cbGroup="hasGroup" @cbSort="sortChange"></ly-advanced-filter>
          <jw-tooltip :content="$t('列设置')">
            <span class="icon-bg-color hand" @click="openColSelect">
              <qf-icon-column-setting />
            </span>
          </jw-tooltip>
          <jw-tooltip content="刷新">
            <span class="icon-bg-color hand" @click="refreshList()" :style="{ opacity: data.loading ? 0.4 : 1, pointerEvents: data.loading ? 'none' : 'auto' }">
              <icon-refresh size="16" />
            </span>
          </jw-tooltip>
        </div>
      </div>

      <fh-table v-if="data.viewId" id="fhTableId" v-on="tPropsEvent" v-bind="tProps" :loading="data.loading" row-key="id" v-model:selectedRowKeys="selectTableIds" @select-change="fhTableSelect" size="small" ref="fhTableRef" :columns="data.columns" lazy-load hover :scroll="{ type: 'virtual', threshold: 40, isFixedRowHeight: true, rowHeight: 32, bufferSize: 10 }" resizable :max-height="listScroll" :onRowClick="rowLevel1Click" :onChange="fhTablePagination" :expand-icon="expandLevel1Icon" @expand-change="rehandleExpandChange" :expanded-row-keys="expandedLevel1RowKeys" active-row-type="single" :activeRowKeys="expandedLevel1RowKeys.concat(expandedActiveLevel1RowKeys)" :class="['list-table', expandLevel1Icon ? 'has-group-table' : '']">
        <template #custom-operations-title>
          <div class="custom-operation-inner"><t-checkbox :checked="selectTableIds?.length === allIds?.length && allIds.length" :indeterminate="indeterminate" @change="selectAll" /></div>
        </template>

        <template #expandIcon>
          <icon-right-circle class="table-expand-icon" />
        </template>

        <template #custom-operations="{ row }">
          <div class="custom-operation-inner" @click.stop="">
            <template v-if="computingStatus.includes(row?.computedInfo?.status)">
              <jw-tooltip content="公式计算中，计算成功后触发后续操作">
                <icon-refresh :size="16" style="color: rgb(var(--primary-6))" spin />
              </jw-tooltip>
            </template>
            <template v-if="row?.computedInfo?.status == 2">
              <ly-computed-icon-tips :computedInfo="row?.computedInfo" :hasChild="expandLevel1Icon" />
            </template>
            <template v-if="buttonBatch.length && !computingStatus.includes(row?.computedInfo?.status)">
              <t-checkbox @click.prevent="selectTd(row.id, $event)" :checked="selectTableIds.includes(row.id)" />
            </template>
          </div>
        </template>

        <!-- 操作按钮部分S -->
        <template #operations="{ row }">
          <div class="operation-button" v-if="buttonShortcut?.length && row.LOGIC_ROLE_PERMISSION && row.LOGIC_ROLE_PERMISSION == 1" @click.stop="">
            <ly-list-shortcut-buttons :viewId="data.viewId" :tProps="tProps" :entityId="entity" :fieldsListAll="buttonShortcut" :recordObj="row" :computedStatus="row.computedInfo?.status" ref="lyListShortcutRef" @cb="shortcutBtnCb" :key="randomKey"></ly-list-shortcut-buttons>
          </div>
          <div v-else>-</div>
        </template>
        <template #computed-status="{ row }">
          <template v-if="computingStatus.includes(row?.computedInfo?.status)">
            <ly-computed-tip :success="true" :hasChild="expandLevel1Icon" />
          </template>
          <template v-else-if="row?.computedInfo?.status == 2">
            <ly-computed-tip :computedInfo="row?.computedInfo" :fieldList="data.columns" :hasChild="expandLevel1Icon" />
          </template>
        </template>
        <!-- 操作按钮部分E -->
        <template v-for="(slotName, slotIndex) in data.slots" #[slotName]="{ row }" :key="slotIndex">
          <ly-template-slot :row="row" :slotsName="slotName" :entity="entity" @cb="refreshList()" />
        </template>
        <!-- 每个对象的主属性字段 -->
        <template #[detailKey(entity)]="{ row }">
          <ly-template-slot :row="row" :detailKey="detailKey(entity)" :entity="entity" @cb="toDetails" />
        </template>
        <!--加载多层级内容(二级) -->
        <template #expandedRow="{ row }">
          <div class="table-level-2-content table-level-content">
            <fh-table :data="data.tableLevel2Data" :pagination="data.tableLevel2pagination" @page-change="onTableLevel2PageChange" lazy-load :scroll="{ type: 'virtual', threshold: 10, rowHeight: 40, bufferSize: 10 }" size="small" :max-height="tableLevelListScroll" :hover="data.tableLevel2Data?.length ? true : false" active-row-type="single" row-key="id" ref="fhTableRefLevel2" :columns="data.tableLevel2Columns" resizable :onRowClick="rowLevel2Click" :expand-icon="expandLevel2Icon" @expand-change="rehandleExpandChange2" :expanded-row-keys="expandedLevel2RowKeys" :loading="loadingObj?.[row.id] || false" :activeRowKeys="expandedLevel2RowKeys.concat(expandedActiveLevel2RowKeys)">
              <template #expandIcon>
                <icon-right-circle class="table-expand-icon" />
              </template>
              <template #computed-status="{ row }">
                <template v-if="computingStatus.includes(row?.computedInfo?.status)">
                  <ly-computed-tip :success="true" :hasChild="expandLevel1Icon" />
                </template>
                <template v-else-if="row?.computedInfo?.status == 2">
                  <ly-computed-tip :computedInfo="row?.computedInfo" :fieldList="data.tableLevel2Columns" :hasChild="expandLevel1Icon" />
                </template>
              </template>
              <template v-for="(slotName, slotIndex) in data.slots" #[slotName]="{ row }" :key="slotIndex">
                <ly-template-slot :row="row" :slotsName="slotName" :entity="getTableLevelEntity(2)" @cb="refreshList()" />
              </template>
              <!-- 每个对象的主属性字段 -->
              <template #[detailKey(getTableLevelEntity(2))]="{ row }">
                <ly-template-slot :row="row" :detailKey="detailKey(getTableLevelEntity(2))" :entity="getTableLevelEntity(2)" @cb="toDetails" />
              </template>
              <!--加载多层级内容(三级) -->
              <template #expandedRow="{ row }">
                <div class="table-level-3-content table-level-content">
                  <fh-table :data="data.tableLevel3Data" :pagination="data.tableLevel3pagination" @page-change="onTableLevel3PageChange" lazy-load :scroll="{ type: 'virtual', threshold: 10, rowHeight: 40, bufferSize: 10 }" size="small" :max-height="tableLevelListScroll" :hover="data.tableLevel3Data?.length ? true : false" row-key="id" ref="fhTableRefLevel3" :columns="data.tableLevel3Columns" resizable :onRowClick="rowLevel3Click" :loading="loadingObj?.[row.id] || false" active-row-type="single" :activeRowKeys="expandedActiveLevel3RowKeys">
                    <template #expandIcon>
                      <icon-right-circle class="table-expand-icon" />
                    </template>
                    <template #computed-status="{ row }">
                      <template v-if="computingStatus.includes(row?.computedInfo?.status)">
                        <ly-computed-tip :success="true" :hasChild="expandLevel1Icon" />
                      </template>
                      <template v-else-if="row?.computedInfo?.status == 2">
                        <ly-computed-tip :computedInfo="row?.computedInfo" :fieldList="data.tableLevel3Columns" :hasChild="expandLevel1Icon" />
                      </template>
                    </template>
                    <template v-for="(slotName, slotIndex) in data.slots" #[slotName]="{ row }" :key="slotIndex">
                      <ly-template-slot :row="row" :slotsName="slotName" :entity="getTableLevelEntity(3)" @cb="refreshList()" />
                    </template>
                    <!-- 每个对象的主属性字段 -->
                    <template #[detailKey(getTableLevelEntity(3))]="{ row }">
                      <ly-template-slot :row="row" :detailKey="detailKey(getTableLevelEntity(3))" :entity="getTableLevelEntity(3)" @cb="toDetails" />
                    </template>
                  </fh-table>
                </div>
              </template>
            </fh-table>
          </div>
        </template>
      </fh-table>
    </template>
    <template v-else>
      <ly-skeleton fromType="mainTable" :lineHeight="22" :row="10"></ly-skeleton>
    </template>
    <!--主对象公共详情  S-->
    <ly-detail ref="detailRef" @cb="refreshList('detail')"></ly-detail>

    <div v-if="data.showColOverlay" class="overlay" @click.stop="showLay(false)"></div>
  </div>
</template>

<script setup lang="jsx">
import { reactive, ref, onMounted, provide, computed, watch, KeepAlive, defineAsyncComponent, nextTick, onBeforeUnmount } from 'vue';
import { layoutService, setService, publicService } from '@/api/';
import LyTemplateSlot from '@/components/layout/ly-template-slot/ly-template-slot.vue'; //列表插槽组件
import useFhTable from '@/hooks/fh-table';
import { tools } from '@/utils/tools';
import CONFIG from '@/config/config';
import { useUserStore, useLayoutStore, useFilterListStore } from '@/store';
import { editFieldTypeList, editEntityList, contractFieldKey, computingStatus } from '@/utils/const';
import useViewFields from '@/hooks/view-fields';
import useEditFields from '@/hooks/edit-field';
import useMainTable from '@/hooks/main-table';
// import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import LyListUniversalButtons from '@/components/layout/ly-list-universal-buttons/ly-list-universal-buttons.vue';
// 根据类型拆分编辑字段成一个小单元
const tableInnerEdit = defineAsyncComponent(() => import('../table-inner-edit/table-inner-edit.vue'));
const linkEditAble = defineAsyncComponent(() => import('../../unit/link-edit-able/link-edit-able.vue'));
const avatarEditAble = defineAsyncComponent(() => import('../../unit/avatar-edit-able/avatar-edit-able.vue'));
const textEditAble = defineAsyncComponent(() => import('../../unit/text-edit-able/text-edit-able.vue'));
const numberEditAble = defineAsyncComponent(() => import('../../unit/number-edit-able/number-edit-able.vue'));
const percentEditAble = defineAsyncComponent(() => import('../../unit/percent-edit-able/percent-edit-able.vue'));
const dateEditAble = defineAsyncComponent(() => import('../../unit/date-edit-able/date-edit-able.vue'));
const selectEditAble = defineAsyncComponent(() => import('../../unit/select-edit-able/select-edit-able.vue'));
const cascadeEditAble = defineAsyncComponent(() => import('../../unit/cascade-edit-able/cascade-edit-able.vue'));
const amountEditAble = defineAsyncComponent(() => import('../../unit/amount-edit-able/amount-edit-able.vue'));
const associationEditAble = defineAsyncComponent(() => import('../../unit/association-edit-able/association-edit-able.vue')); //查找关联多选
const departEditAble = defineAsyncComponent(() => import('../../unit/depart-edit-able/depart-edit-able.vue'));
const lyAvatar = defineAsyncComponent(() => import('../../layout/ly-avatar/ly-avatar.vue'));
const xlStatus = defineAsyncComponent(() => import('../../xl-status/xl-status.vue'));
const lyAttachmentList = defineAsyncComponent(() => import('../../layout/ly-attachment-list/ly-attachment-list.vue'));
const lyAssociation = defineAsyncComponent(() => import('../../layout/ly-association/ly-association.vue'));
const associationNonEditAble = defineAsyncComponent(() => import('../../unit/association-non-edit-able/association-non-edit-able.vue'));
const lyComputedCmp = defineAsyncComponent(() => import('../../unit/computed-cmp/computed-cmp.vue'));
const lyRichText = defineAsyncComponent(() => import('../../layout/ly-rich-text/ly-rich-text.vue'));
const lyTagFields = defineAsyncComponent(() => import('../../layout/ly-tag-fields/ly-tag-fields.vue'));
// import dayjs from 'dayjs';
const useLayout = useLayoutStore(); //视图及布局store
const useFilterList = useFilterListStore(); // 筛选条件store
// const route = useRoute();
const { setEditFieldVal } = useEditFields();
const { highConditionsList, getConditionList } = useMainTable();
const props = defineProps({
  entityId: {
    //对象的entity【必传】
    type: Number || String,
    default: undefined
  },
  viewId: {
    type: Number || String,
    default: undefined
  },
  record: {
    type: Object,
    default: () => ({})
  },
  fieldGroups: {
    type: Array,
    default: () => []
  },
  // 暂时去掉，是否展示操作区域根据是否配置按钮权限
  // operations: {
  //   //操作区域默认宽度是180，如有操作区域宽度请传参数
  //   type: Number,
  //   default: 180
  // },
  customerId: {
    type: Number || String
  },
  isFilter: {
    // 是否支持筛选，默认支持
    type: Boolean,
    default: true
  }
});
const { t } = useI18n();
//类型1-线索 2-客户 3-商机 4-产品 6--报价单详情 7--报价单明细 8 销售合同 9 销售合同明细10销售订单13退货单14退货单产品
const entity = ref(props.entityId);
const randomKey = ref(0);
const detailKey = (entity) => {
  const keyMap = {
    //主属性
    1: 'companyName',
    2: 'customerName',
    3: 'opportunityName',
    4: 'productName',
    6: 'priceSheetCode',
    8: 'code', // 合同使用 'code'
    10: 'code', // 销售订单也使用 'code'
    12: 'salesNo',
    13: 'code', // 退货单也使用 'code'
    16: 'dynamicRecord',
    101: 'companyName' // 线索池也使用 'companyName'
  };
  return keyMap[entity] || '';
};

// const slotList = (entity) => {
//   if (entity === 1) {
//     return ['clueStatus', 'intentionality', 'isImportant'];
//   } else if (entity === 101) {
//     return ['clueStatus', 'intentionality', 'isImportant'];
//   } else if (entity === 2) {
//     return ['customerName', 'qccId', 'intentionality', 'isDealt', 'important', 'lastFollowContent'];
//   } else if (entity === 8) {
//     return ['esignStatus', 'fsContractId'];
//   } else if (entity === 10) {
//     return ['totality', 'billPeriod', 'fsContractId', 'amount'];
//   }
//   {
//     return [];
//   }
// };
const fieldsSort = ref([]);
const windowHeight = ref(0);
console.log('cc', windowHeight);
const listScroll = ref(null);
const data = reactive({
  dataPermission: 0,
  fieldList: [], //获取字段列表所有数据
  // filterFieldList: [], //筛选的字段
  multiTable: null, //多层级表格信息
  tableLevel2Columns: [], //二层级表头信息
  tableLevel2Data: [], //二层级表格数据
  tableLevel2RowData: {}, //点击展开行时当前条数据
  loading: true,
  tableLevel3Columns: [], //三层级表头信息

  tableLevel3Data: [], //三层级表格数据
  tableLevel3RowData: {}, //点击展开行时当前条数据

  tableLevel: '', //表格层级（2/3）
  setEntity: '', //更新对象的entity
  tableLevel2pagination: {
    //二层级表格分页
    current: 1,
    pageSize: 5,
    total: 0,
    foldedMaxPageBtn: 2,
    maxPageBtn: 4,
    showPageSize: true, // 是否显示数据条数选择器
    showJumper: true,
    size: 'small',
    // model: 1,
    pageSizeOptions: [5, 10, 20, 30],
    showTotal: true // 是否显示数据总数
  },
  tableLevel3pagination: {
    //三层级表格分页
    current: 1,
    pageSize: 5,
    total: 0,
    foldedMaxPageBtn: 2,
    maxPageBtn: 4,
    showPageSize: true, // 是否显示数据条数选择器
    showJumper: true,
    size: 'small',
    // model: 1,
    pageSizeOptions: [5, 10, 20, 30],
    showTotal: true // 是否显示数据总数
  },
  customFieldList: [], //客户表头
  columns: [],
  poolLoading: false, //线索池领取loading
  id: '', //ID、
  account_id: '',
  tab: '',
  record: [],
  leadsID: [],
  viewId: null,
  // selectType: 0,
  editFieldTypeList: [0, 1, 2, 3, 4, 5], //可编辑的字段类型
  editEntityList: { 1: ['mobile', 'personName'], 2: ['mobile', 'personName'], 3: ['mobile', 'personName', 'opportunityStage', 'opportunityStatus'], 4: [], 6: [], 7: [], 8: [], 9: [], 10: [], 11: [], 12: [], 13: [], 14: [], 32: [], 101: ['mobile', 'personName'] },
  // 客户模块
  bingDataInput_rbKcJb: '',
  permissionsObjList: {
    //编辑权限
    1: 'clue:edit',
    2: 'customer:edit',
    3: 'businessOpportunity:edit',
    4: 'product:edit',
    6: 'priceSheet:edit',
    //   7: '报价单产品',
    8: 'contract:edit',
    //   9: '合同产品',
    10: 'saleOrder:edit',
    //   11: '订单产品',
    12: 'afterSale:edit',
    13: 'returnOrder:edit',
    16: 'dynamicRecord:edit',
    //   14: '退货单产品',
    //   32: '商机产品',
    101: 'cluePool:edit'
  },
  slots: ['intentionality', 'customerLevel', 'clueStatus', 'isImportant', 'qccId', 'isDealt', 'important', 'lastFollowContent', 'amount', 'isExistContract', 'fsContractId', 'esignStatus', 'totality', 'billPeriod'], //插槽的列表
  ruleForm: {
    fieldKey: t('全部数据'), //数据条件
    leadsFieldList: [], //第一个
    objList: {}, //fieldKey：obj 类型
    filterType: {}, //中间
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    conditions: []
    //conditions: [{ id: undefined, operation: 'and', isGroup: true, parentId: undefined, children: [{ id: undefined, operation: '', isGroup: false, parentId: undefined, field: '', value: null }] }]
  },
  qccID: [
    {
      label: '为空',
      value: 'null',
      business: null,
      deleted: null
    },
    {
      label: '不为空',
      value: 'not_null',
      business: null,
      deleted: null
    }
  ],
  showColOverlay: false, // 父组件弹窗状态
  colOverlayId: undefined, // 哪列弹窗
  specialProduct: [7, 9, 11, 14, 32] //特殊产品对象
});
const poolId = ref(); //线索池id
const findAssociation = { label: t('属于当前值'), value: 'equals_current_value' };
const universalButtonParams = ref({});
//兼容自定义
if (entity.value >= 200) {
  data.permissionsObjList[entity.value] = `${entity.value}:edit`;
}
const emits = defineEmits(['cb', 'cbGroup']);
const detailRef = ref(); //公共抽离组件
const lyListShortcutRef = ref(null);
// 是否在飞书环境ss
// const isFeiShuApp = window.h5sdk;

const filterDataObj = ref({});
const { userInfo } = useUserStore(); //用户信息
// const buttonTexts = ref([]);
// if (entity.value) {
//   buttonTexts.value = tools.getOptTextsByEntity(userInfo?.menus?.entityResources, entity.value);
// }

// 表格表头数据字段getFilterParams,fitlterLayoutFields,
const { fieldsListAll, layoutFieldList, getLayoutFieldsObject } = useViewFields();
// 可编辑表格的hooks
// const { getEditTableProps } = useEditTable();
const clearRowKeys = () => {
  //清空高亮行
  expandedActiveLevel2RowKeys.value = []; //二级高亮行
  expandedActiveLevel3RowKeys.value = []; //三级高亮行
  expandedActiveLevel1RowKeys.value = [];
};
// 点击一级表格
const rowLevel1Click = (context) => {
  clearRowKeys();
  expandedActiveLevel1RowKeys.value.push(context.row.id);
  context.e.stopPropagation();
  toDetails(context.row);
};
// 点击行（二级）
const rowLevel2Click = (context) => {
  clearRowKeys();
  expandedActiveLevel2RowKeys.value.push(context.row.id);

  context.e.stopPropagation();
  toDetails(context.row);
};
// 点击行（三级）
const rowLevel3Click = (context) => {
  clearRowKeys();
  expandedActiveLevel3RowKeys.value.push(context.row.id);

  context.e.stopPropagation();
  toDetails(context.row);
};
const indeterminate = computed(() => {
  return selectTableIds.value.length > 0 && selectTableIds.value.length < allIds.value.length;
});

const selectAll = () => {
  console.log('全选333333', selectTableIds.value, allIds.value);

  if (selectTableIds.value.length === allIds.value.length) {
    selectTableIds.value = [];
  } else {
    selectTableIds.value = allIds.value;
  }
};

const selectTd = (rowId, e) => {
  e.preventDefault();
  const handleIndex = selectTableIds.value?.findIndex((item) => item == rowId);
  if (handleIndex > -1) {
    // 已经存在
    selectTableIds.value.splice(handleIndex, 1);
  } else {
    selectTableIds.value.push(rowId);
  }
  console.log('选择td', selectTableIds.value);
};

const toDetails = (record) => {
  console.log('toDetails', record);
  //获取对象entity
  const getEntity = getTableLevelEntity(record?.tableLevel || 1);
  if (data.specialProduct.includes(Number(getEntity))) {
    //特殊产品显示不能点击状态
    return false;
  }
  data.setEntity = getEntity;
  data.tableLevel = record?.tableLevel || '';
  // console.log(229, record, data.setEntity);
  data.id = record?.id;
  detailRef.value?.closeDialog?.();

  if (data.setEntity == 1) {
    // 点击公司名称--线索详情
    data.tab = 'clueDetail';
  } else if (data.setEntity == 2) {
    //点击公司名称--客户详情
    data.tab = 'clientDetail';
  } else if (data.setEntity == 3) {
    // 点击商机名称--商机详情
    data.account_id = record.account_id;
    data.tab = 'opportunityDetail';
  } else if (data.setEntity == 4) {
    // 点击产品管理--产品管理详情
    data.tab = 'productDetail';
  } else if (data.setEntity == 6) {
    // 点击报价单名称--报价单详情
    data.tab = 'priceSheetDetail';
  } else if (data.setEntity == 8) {
    // 点击合同编号--合同详情
    data.tab = 'contractDetail';
  } else if (data.setEntity == 10) {
    // 点击销售订单编号--销售订单详情
    data.tab = 'orderDetail';
  } else if (data.setEntity == 12) {
    // 点击售后服务编号--售后服务详情
    data.tab = 'serviceDetail';
  } else if (data.setEntity === 13) {
    // 点击销售退货编号--销售退货单详情
    data.tab = 'returnOrderDetail';
  } else if (data.setEntity == 101) {
    // 点击线索池公司名称--线索池详情
    data.tab = 'cluePoolDetail';
  }
  detailRef.value.openDialog();
};
const highSearch = {};
// 获取scope的值
const scopeKey = `${CONFIG.prefix}_list_scope`;
const scopeLimit = ref(tools.getCookie(scopeKey) || 0);
// const poolHightSelectList = ref([]);

//搜索
// const randomKey = computed(() => `${entity.value}_${data.viewId}`);

// 获取计算字段错误信息

//组装表格数据 表格数据 计算字段数据
const AssTableData = (tableData, computedInfoList) => {
  const resultData = [...tableData];
  resultData.forEach((itemA) => {
    const matchingItem = computedInfoList?.find((itemB) => itemB.businessId === itemA.id);
    if (matchingItem) {
      // 如果找到了匹配项，就把 computed 的值添加到 数据 中
      itemA.computedInfo = matchingItem;
    } else {
      itemA.computedInfo = null;
    }
  });
  return resultData;
};

const getComputedErrorLog = async (businessIdList, entityParams) => {
  try {
    const json = await setService.getComputedErrorLog({
      entity: entityParams,
      businessIdList: businessIdList
    });
    if (!json.error) {
      const result = json.result;
      return result;
    }
  } catch (error) {
    console.log(error);
  }
};

// 判断是否计算中数据 1 计算中 2 计算完成
const checkIsComputing = (data) => {
  return !computingStatus.includes(data?.computedInfo?.status) || !data.computedInfo;
};

// 创建一个ref来存储定时器id
const timer = ref(null);
// 轮询计算状态并组装数据
const pollComputedStatus = async (entity, data) => {
  // 标记是否是首次执行
  const isFirstRun = ref(true);
  // 获取数据id
  const getBusinessIds = (tableData) => {
    if (isFirstRun.value) {
      return tableData.map((dItem) => dItem.id);
    }
    return tableData.filter((item) => item?.computedInfo).map((item) => item.id);
  };
  const poll = async () => {
    try {
      // 根据是否首次执行决定查询哪些数据的id
      const businessIdList = getBusinessIds(data);

      isFirstRun.value = false;

      // 如果没有需要查询的id，说明没有计算中的数据，可以停止轮询
      if (!businessIdList.length) {
        clearInterval(timer.value);
        timer.value = null;
        return;
      }

      const computedInfo = await getComputedErrorLog(businessIdList, entity);
      const newData = AssTableData(data, computedInfo);
      // 更新表格数据
      tProps.value.data = newData;

      // 更新allIds
      allIds.value = newData.filter((dItem) => checkIsComputing(dItem))?.map((mItem) => mItem.id);
      // 如果所有数据都已经计算完成，清除定时器
      const allCompleted = newData.every((item) => checkIsComputing(item));
      if (allCompleted) {
        clearInterval(timer.value);
        timer.value = null;
      }
    } catch (error) {
      console.log(error);
      // 发生错误时也清除定时器
      clearInterval(timer.value);
      timer.value = null;
      return data;
    }
  };
  // 立即执行一次
  await poll();
  // 设置定时器，每3秒轮询一次
  if (timer.value === null) {
    timer.value = setInterval(poll, 3000);
  }
};

// 组件卸载时清除定时器
onBeforeUnmount(() => {
  if (timer.value) {
    clearInterval(timer.value);
    timer.value = null;
  }
});

const filterParams = ref({});
const allIds = ref([]);

const cb = async (data) => {
  // 每次切换数据 清除定时器
  if (timer.value) {
    clearInterval(timer.value);
    timer.value = null;
  }
  // 存在数据 进行数据轮询组装
  if (data.length) {
    await pollComputedStatus(entity.value, data);
  }
};
//表格
const { tProps, tPropsEvent, setTProps, setLoadListParams, loadTList } = useFhTable(layoutService.getObjectListPage.bind(layoutService), cb);
const expandedLevel1RowKeys = ref([]); //一级存储展开行的值
const expandedActiveLevel1RowKeys = ref([]); //一级高亮行
const expandedLevel2RowKeys = ref([]); //二级存储展开行的值
const expandedActiveLevel2RowKeys = ref([]); //二级高亮行
const expandedActiveLevel3RowKeys = ref([]); //三级高亮行
// 设置额外的props
setTProps({
  uuid: computed(() => data.viewId)
});
const isFirst = ref(true); // 首次不触发保存筛选
let hasObserved = false; // 新增标记变量
const renderStartTime = ref(null);
const renderEndTime = ref(null);
const renderDuration = ref(null);
// 高级筛选组件的回调事件
const getSearchData = async (v) => {
  console.log('清除操作', v, isFirst.value, v.type);
  // eslint-disable-next-line no-debugger
  // debugger;

  // 线索池特殊处理--存储线索池id
  if (entity.value == 101 && v?.sceneId) {
    poolId.value = v?.sceneId;
  }

  if (isFirst.value) {
    v.conditions = data.ruleForm?.conditions;
  } else {
    data.ruleForm.conditions = v?.conditions || [];
    if (v.type) {
      // 保存筛选数据
      await useFilterList.setConditionsList({ entity: entity.value, conditions: v?.conditions });
    }
  }
  delete v.type;
  // 更新筛选条件的值，导出组件使用
  const params = {
    viewId: data.viewId,
    filterParams: {
      conditions: v?.conditions,
      scope: v.sceneType === 0 ? v.sceneId : null,
      sceneId: v.sceneType === 1 ? v.sceneId : null,
      viewId: data.viewId,
      searchConditions: v?.searchConditions
    },
    pagination: tProps.value.pagination
  };
  if (useFilterList?.fieldsSort?.length) {
    v.sortSettings = useFilterList?.fieldsSort?.filter((item) => item.fieldStatus == 1) || [];
    v.sortSettings = JSON.parse(JSON.stringify(v))?.sortSettings.map((item) => {
      item.sort = item.fieldSort;
      delete item.fieldSort;
      return item;
    });
  }
  // emits('cb', { type: 2, params });
  universalButtonParams.value = params;
  data.loading = true;
  // 重置listPage接口参数
  setLoadListParams({ ...v, id: data.viewId, entity: entity.value });
  selectTableIds.value = [];
  await loadTList(1);
  renderStartTime.value = performance.now();
  console.log(422, data.viewId);
  const tableId = document.getElementById('fhTableId');
  // 记录开始时间
  if (isFirst.value) {
    const observeTableRender = () => {
      return new Promise((resolve) => {
        const observer = new MutationObserver(() => {
          requestAnimationFrame(() => {
            if (tableId && tableId.querySelectorAll('tr')?.length) {
              renderEndTime.value = performance.now();
              renderDuration.value = renderEndTime.value - renderStartTime.value;
              console.log(`表格渲染完成耗时：${renderDuration.value}毫秒`);
              observer.disconnect();
              resolve();
            } else {
              renderDuration.value = 0;
            }
          });
        });
        if (observer?.observer && tableId && !hasObserved) {
          observer.observe(tableId, {
            childList: true,
            subtree: true
          });
          hasObserved = true; // 调用后设置为已调用
        } else {
          renderDuration.value = 0;
          resolve(); // 直接 resolve，避免 Promise 一直处于 pending 状态
        }
      });
    };
    await observeTableRender();
    setTimeout(() => {
      isFirst.value = false;
      console.log(457, renderDuration.value, isFirst.value);
    }, renderDuration.value);
  }
  console.log(443, renderDuration.value);
  data.loading = false;
  setTimeout(() => {
    isFirst.value = false;
  }, renderDuration.value);
  expandedLevel1RowKeys.value = [];
  expandedLevel2RowKeys.value = [];
};
// 如果需要列选择，就需要在自己需要的地方自定义一个按钮，实现table的这个事件 开始 S
const fhTableRef = ref(null); // 表格ref
// 打开列选择
const openColSelect = () => {
  fhTableRef.value?.openColSelect();
};
// 刷新表格
// const refreshTable = (index, params) => {
//   setData(index, params);
// };

const ids = ref([]);
const bingDataList = ref([]);
const selectTableIds = ref([]); //选择的数据ID
const fhTableSelect = (rowKeys) => {
  console.log('rowKeys', rowKeys);
  selectTableIds.value = rowKeys;
  //选择当前页
  const list = tProps.value.data;
  const filterList = list?.filter((v) => selectTableIds.value?.includes(v.id));
  console.log('rowKeys', filterList);
  if (entity.value == 2) {
    bingDataList.value = filterList.map((v) => v.input_rbKcJb);
  } else if (entity.value == 3) {
    bingDataList.value = filterList.map((v) => v.account_id);
  } else if (entity.value == 10) {
    bingDataList.value = filterList.map((v) => v.id);
  } else if (entity.value >= 200 && userInfo?.roles?.indexOf(`${entity.value}:bingUserInviteSync`) !== -1) {
    bingDataList.value = filterList.map((v) => v?.id);
  }
  if (selectTableIds.value?.length === 0) {
    lyListUniversalButtonsRef.value?.getBtnPermissionObj(fieldsListAll.value.buttonUniversal);
  }
};
// 分页改变触发时如果批量操作中有数据，则清空数据
const fhTablePagination = ({ pagination }) => {
  if (pagination && selectTableIds.value?.length) {
    selectTableIds.value = [];
  }
};
// 获取所有字段值,生成表格头部
const buttonBatch = ref([]);
const buttonShortcut = ref([]);
const operationItem = computed(() => {
  return buttonShortcut.value?.length === 0 ? 0 : buttonShortcut.value?.length <= 3 ? 120 : 160;
});
const searchInit = (viewId) => {
  filterDataObj.value = {
    viewId: viewId.viewId,
    entity: entity.value,
    highSearch: {
      value: scopeLimit.value ? Number(scopeLimit.value) : 0,
      list: []
    },
    fieldSearch: {
      value: '',
      list: []
    }
  };
};
console.log(411, data.dataPermission, filterDataObj.value);
const isShowFilter = ref(true);
const fieldFilterList = ref({}); //字段筛选下拉选项值
const skeletonLoading = ref(false);
const lyListUniversalButtonsRef = ref(); //公共组件ref

// 给子组件调用
// const addFieldsSortFun = () => {
//   addFieldsSort(data.fieldList, fieldsSort.value);
// };

// 追加排序字段
const addFieldsSort = (fieldList, fieldsSort) => {
  if (fieldList?.length && fieldsSort?.length) {
    fieldList?.forEach((item) => {
      const obj = fieldsSort?.find((e) => {
        return e.fieldKey == item.fieldKey;
      });
      if (obj) {
        if (obj.fieldSort === true || obj.fieldSort === false) {
          item.fieldSort = obj.fieldSort;
        } else {
          item.fieldSort = '';
        }
      } else {
        item.fieldSort = '';
      }
    });
  }
  // 当没有排序字段时  清空 fieldList 里的 fieldSort
  if (fieldsSort?.length == 0) {
    fieldList?.forEach((item) => (item.fieldSort = ''));
  }
};
const getField = async (viewId) => {
  clearRowKeys();
  isShowFilter.value = false;
  data.viewId = viewId?.viewId || props.viewId;
  data.dataPermission = viewId.dataPermission;
  data.loading = true;
  await getConditionList(); //获取高级筛选下拉选项值
  searchInit(viewId);
  skeletonLoading.value = true;
  if (tProps.value?.data?.length) tProps.value.data = [];
  await getLayoutFieldsObject({ entity: entity.value, viewId: data?.viewId || null }); //获取所有字段
  skeletonLoading.value = false;
  data.fieldList = layoutFieldList.value; //列表显示的字段 //.filter((v) => v.fieldType !== 18);
  console.log('fieldList.value', data.fieldList);
  if (useFilterList?.fieldsSort && useFilterList?.fieldsSort?.length) {
    addFieldsSort(data.fieldList, useFilterList?.fieldsSort);
  }
  fieldFilterList.value = fieldsListAll.value?.dropdowns;
  data.multiTable = fieldsListAll.value?.multiTable; //多层级表格信息
  data.columns = getColumns();

  console.log('fieldsListAll.value', fieldsListAll.value);

  // 批量按钮权限
  if (fieldsListAll.value?.buttonBatch?.length) {
    buttonBatch.value = fieldsListAll.value?.buttonBatch.map((item) => item.value);
  }
  // 快捷按钮权限
  if (fieldsListAll.value?.buttonShortcut?.length) {
    buttonShortcut.value = fieldsListAll.value?.buttonShortcut.map((item) => item.value);
  }
  //刷新父组件ly-list中公共区域的按钮权限
  // emits('cb', { type: 1, params: fieldsListAll.value });
  nextTick(() => {
    data.columns = getColumns();
    console.log('columns', data.columns);
    lyListUniversalButtonsRef.value?.getBtnPermissionObj(fieldsListAll.value.buttonUniversal);
  });
  // isShowFilter的作用：保证再拿到数据后才渲染筛选组件；
  isShowFilter.value = true;
};
const loadingObj = ref({});

//多层级获取对象
const getTableLevelEntity = (type) => {
  if (type == 1) {
    //一级
    return entity.value || '';
  }
  if (type == 2) {
    //二级
    return data.multiTable?.businessData || '';
  }
  if (type == 3) {
    //三级
    return data.multiTable?.modules?.filter((list) => list.type == 30)?.[0]?.businessData || '';
  }
};
data.setEntity = getTableLevelEntity(1); //默认调用一次 是主对象entity
// 是否开启多层级表格（一级）
const expandLevel1Icon = computed(() => {
  return data.multiTable && data.multiTable?.modules?.length > 0 ? true : false;
});
// 是否多层级表格（二级）
const expandLevel2Icon = computed(() => {
  return data.multiTable?.modules?.filter((list) => list.type == 30)?.[0]?.modules?.length > 0 ? true : false;
});
//多层级分页（二级）
const onTableLevel2PageChange = async (pageInfo) => {
  data.tableLevel2pagination.current = pageInfo.current;
  data.tableLevel2pagination.pageSize = pageInfo.pageSize;
  await getTableEntityData(2);
};
//多层级分页（三级）
const onTableLevel3PageChange = async (pageInfo) => {
  data.tableLevel3pagination.current = pageInfo.current;
  data.tableLevel3pagination.pageSize = pageInfo.pageSize;
  await getTableEntityData(3);
};
const tableLevelListScroll = ref(320); //多层级限高
// 多层级表格渲染
const getTableLevelColumns = (source) => {
  const list = [];
  let getColumnsList = [];
  const businessData = getTableLevelEntity(source); //获取对象entity
  if (source == 2) {
    //二级表格
    getColumnsList = data.multiTable?.modules?.filter((item) => item.type == 20);
    // eslint-disable-next-line no-debugger
    console.log('二级表格', getColumnsList);
  }
  if (source == 3) {
    //三级表格
    getColumnsList = data.multiTable?.modules?.filter((list) => list.type == 30)?.[0]?.modules?.filter((item) => item.type == 20);
    console.log('三级表格', getColumnsList);
  }
  getColumnsList?.forEach((item) => {
    const fieldKey = item?.setting?.fieldKey; //字段标识
    const frozen = item?.businessData; //是否为固定行
    const fieldType = item?.setting?.fieldType == 21 ? item?.setting?.business?.fieldType : item?.setting?.fieldType; //字段类型
    const fieldExt = item?.setting?.fieldType == 21 ? item?.setting?.business?.fieldExt : item?.setting?.fieldExt;
    const fieldName = item?.setting?.fieldName; //字段名称
    const type = item.setting.type; //字段类型
    const mainField = item?.setting?.mainField || false; // 主属性字段
    const width = mainField ? 250 : tools.getStrLen(fieldName) <= 6 ? 120 : tools.getStrLen(fieldName) > 10 ? 220 : tools.getStrLen(fieldName) * 20;
    // 表格的className属性设置单元格的类名
    const colType = {
      title: fieldName,
      colKey: fieldKey,
      type: type,
      ellipsisTitle: { theme: 'light' },
      ellipsis: [3, 5, 12, 25].includes(fieldType) || (item.type == 0 && fieldType == 5) ? undefined : { theme: 'default' },
      id: item.setting.id,
      stopPropagation: [12, 25].includes(fieldType) ? true : false,
      fieldName: fieldName,
      fieldType: fieldType,
      fieldExt: fieldExt,
      resize: tools.getStrLen(fieldName) <= 5 ? { minWidth: 120 } : tools.getStrLen(fieldName) > 10 ? { minWidth: 300 } : { minWidth: tools.getStrLen(fieldName) * 30 },
      fixed: frozen ? 'left' : undefined
    };
    // 表格的cell函数
    const render = (h, { row }) => {
      const record = JSON.parse(JSON.stringify(row));
      const params = {
        ...item,
        type: type,
        fieldValue: record[fieldKey],
        fieldType: fieldType,
        oldFieldType: item?.setting?.fieldType, //兼容引用字段
        fieldExt: fieldExt,
        fieldKey: fieldKey,
        record: record,
        entity: businessData,
        mainField: mainField
      };
      return setRender(h, params, false);
    };
    if (type === 1) {
      colType.colType = t(t('基础字段'));
    }
    if (fieldKey === detailKey(businessData)) {
      //跳转详情的key
      colType.slotName = fieldKey;
      colType.width = 250;
      //自定义插槽
    } else if (data.slots?.indexOf(fieldKey) > -1) {
      // 2024/07/26曹建博去掉自定义插槽 slotName: k，添加render,

      colType.slotName = fieldKey;
      colType.width = 200;
    } else if (fieldType === 8 || fieldType === 9 || fieldType === 18) {
      colType.width = 200;
      colType.cell = render;
    } else {
      colType.width = width;
      colType.cell = render;
    }
    list.push(colType);
  });
  list.unshift(createRowComputedColumn());

  console.log('三级表格columns', list);
  return list;
};

//点击展开图标(加载二级)
const rehandleExpandChange = (value, params) => {
  //   console.log('rehandleExpandChange1', value, params);
  expandedLevel1RowKeys.value = [];
  expandedLevel2RowKeys.value = [];
  data.tableLevel2Data = [];
  if (value && value?.length > 0) {
    //清空分页
    data.tableLevel2pagination.current = 1;
    expandedLevel1RowKeys.value.push(value[value.length - 1]);
    loadingObj.value[params.currentRowData.id] = true;
    data.tableLevel2RowData = params.currentRowData;
    data.tableLevel2Columns = getTableLevelColumns(2);
    console.log('二级表格配置信息333', data.tableLevel2Columns);
    getTableEntityData(2);
  }
};
//点击展开图标(加载三级)
const rehandleExpandChange2 = (value, params) => {
  //   console.log('rehandleExpandChange2', value, params);
  expandedLevel2RowKeys.value = [];
  data.tableLevel3Data = [];
  if (value && value?.length > 0) {
    //清空分页
    data.tableLevel3pagination.current = 1;
    expandedLevel2RowKeys.value.push(value[value.length - 1]);
    // 动态控制loading显示状态
    loadingObj.value[params.currentRowData.id] = true;
    data.tableLevel3RowData = params.currentRowData;
    data.tableLevel3Columns = getTableLevelColumns(3);
    getTableEntityData(3);
  }
};

const getObjEntity = (type) => {
  if (type === 1) {
    return data.setEntity; // 最外层表格
  }
  if (type === 2) {
    return entity.value || '';
  }
  if (type === 3) {
    console.log('三级表格ccc', data.multiTable.businessData);

    return data.multiTable.businessData || '';
  }
};
// 获取多层级表格数据
const getTableEntityData = async (type) => {
  const businessDataEntity = getTableLevelEntity(type); //获取对象entity
  const itselfTableEntity = getObjEntity(type); // 获取关联对象entity
  console.log('关联对象表格');
  let layoutId = null; //布局id
  let layoutConfigId = null; //布局的id
  let businessId = null; //数据id
  let current = null; //当前页
  let pageSize = null; //每页数量

  if (type == 2) {
    //二级表格
    layoutId = data.multiTable?.layoutId;
    layoutConfigId = data.multiTable?.id;
    businessId = data.tableLevel2RowData.id; //数据id
    current = data.tableLevel2pagination.current;
    pageSize = data.tableLevel2pagination.pageSize;
    // data.tableLevel2Loading = true;
  }
  if (type == 3) {
    //三级表格
    layoutId = data.multiTable?.modules?.filter((list) => list.type == 30)?.[0]?.layoutId;
    layoutConfigId = data.multiTable?.modules?.filter((list) => list.type == 30)?.[0]?.id;
    businessId = data.tableLevel3RowData.id; //数据id
    current = data.tableLevel3pagination.current;
    pageSize = data.tableLevel3pagination.pageSize;
    // data.tableLevel3Loading = true;
  }
  const params = {
    itselfTableEntity: itselfTableEntity,
    tableEntity: businessDataEntity,
    layoutId: layoutId,
    layoutConfigId: layoutConfigId,
    businessId: businessId, //数据id
    page: current,
    pageSize: pageSize,
    apiIndex: `${businessDataEntity}_${businessId}_${Math.random() * 100}`
  };
  try {
    const res = await publicService.getTableEntityData(params);
    if (!res.error) {
      const rt = res.result;

      rt.records?.forEach((item) => {
        item.tableLevel = type;
      });
      if (type == 2) {
        data.tableLevel2pagination.page = rt.current;
        data.tableLevel2pagination.total = rt.total;
        const businessIdList = rt.records.map((rItem) => rItem.id);
        const computedInfo = await getComputedErrorLog(businessIdList, businessDataEntity);
        data.tableLevel2Data = AssTableData(rt.records, computedInfo);
        console.log('耳机表格', data.tableLevel2Data);
      } else {
        data.tableLevel3pagination.page = rt.current;
        data.tableLevel3pagination.total = rt.total;
        const businessIdList = rt.records.map((rItem) => rItem.id);
        const computedInfo = await getComputedErrorLog(businessIdList, businessDataEntity);
        data.tableLevel3Data = AssTableData(rt.records, computedInfo);
        console.log('耳机表格', data.tableLevel2Data);
      }
    }
    loadingObj.value[businessId] = false;
  } catch (e) {
    loadingObj.value[businessId] = false;
    console.log(e);
  }
};
// const adc = ref(true);
const skeletonStyles = {
  display: 'inline-block',
  width: '100%',
  height: '24px',
  backgroundColor: 'var(--color-fill-2)',
  animation: `skeleton-blink 1s linear infinite alternate,skeleton-flow 1s linear infinite alternate`,
  backgroundImage: 'linear-gradient(90deg, var(--color-fill-2) 25%, rgba(255, 255, 255, 0.3) 50%, var(--color-fill-2) 75%)',
  backgroundSize: '400% 100%'
};
// console.log(731, fieldTypeUnit.value);
// 表格的render抽离  isEdit:列表是否走编辑逻辑。多层级表格不支持编辑
const setRender = (h, params, isEdit) => {
  const setEntity = isEdit ? entity.value : params.entity; //兼容多层级表格，多层级表格是传过来的entity（entity.value是主表对象，params.entity是多层级对象）
  let setFieldValue = params.fieldValue;
  let isRuleEdit = true;
  let isRuleRequired = params?.isRequired;
  if (params?.record?.FIELD_PERMISSIONS && Object.keys(params?.record?.FIELD_PERMISSIONS)?.length) {
    const _ruleFields = Object.keys(params?.record?.FIELD_PERMISSIONS);
    isRuleEdit = !_ruleFields?.includes(params?.fieldKey) || params?.record?.FIELD_PERMISSIONS[params?.fieldKey]?.includes('w');
    if (_ruleFields?.includes(params?.fieldKey)) {
      isRuleRequired = params?.record?.FIELD_PERMISSIONS[params?.fieldKey]?.includes('!');
    }
  }
  const isEditTableRow = isRuleEdit && !['businessId', 'entityType'].includes(params.fieldKey) && params?.oldFieldType != 21 && !editFieldTypeList?.includes(params.fieldType) && params.type != 0 && ((setEntity >= 200 && params.fieldKey != 'chargePerson') || (setEntity < 200 && !editEntityList[setEntity]?.includes(params.fieldKey))) && !contractFieldKey.includes(params.fieldKey);
  const editParams = {
    fieldInfo: params?.fieldInfo,
    isList: true,
    loading: data.loading,
    entity: setEntity,
    fieldValue: setFieldValue,
    originalValue: params.fieldValue, //原值
    fieldExt: params.fieldExt,
    fieldType: params.fieldType,
    fieldKey: params.fieldKey,
    fieldName: params.fieldName,
    isRequired: isRuleRequired, //是非必填
    mainField: params.mainField,
    subEntityId: params?.subEntityId, //子表单的EntityId
    isSubForm: params?.isSubForm, //是子表
    uniqueValue: params.record['id'] + params.id, //唯一值
    businessId: params.record['id'], //这条数据的id
    permissions: params.record['LOGIC_ROLE_PERMISSION'], //权限
    status: params.record['status'], //生命状态
    statusOrigin: params.record['statusOrigin'], //生命状态
    lockedOrigin: params.record['lockedOrigin'], // 锁定
    computedInfo: params.record?.['computedInfo'] ? params.record?.['computedInfo'] : params?.computedInfo ? params.computedInfo : null //计算状态
  };
  // 创建映射对象，将不同的fieldType值或范围映射到对应的组件上
  const componentMap = {
    0: textEditAble,
    1: textEditAble,
    2: selectEditAble,
    3: selectEditAble,
    4: selectEditAble,
    5: selectEditAble,
    6: avatarEditAble,
    7: numberEditAble,
    8: dateEditAble,
    9: dateEditAble,
    10: cascadeEditAble,
    11: linkEditAble,
    12: linkEditAble,
    16: amountEditAble,
    18: tableInnerEdit,
    22: departEditAble,
    23: percentEditAble,
    25: associationEditAble,
    26: textEditAble
  };
  // 创建对象映射不可编辑组件
  const moreComponentMap = {
    4: xlStatus,
    6: lyAvatar,
    12: lyAssociation,
    18: lyAttachmentList,
    25: associationNonEditAble,
    26: lyRichText
  };
  const nSelectComponent = moreComponentMap[params.fieldType];
  // 从映射对象中获取对应的组件，如果不存在则使用默认的tableInnerEdit组件
  const selectedComponent = componentMap[params.fieldType] || tableInnerEdit;
  if ((params.fieldValue || params.fieldValue === 0) && params.fieldValue !== '') {
    setFieldValue = setEditFieldVal(params.fieldType, params.fieldValue, params.fieldExt); //处理可编辑字段的值
    // 可编辑逻辑
    if (isEditTableRow && isEdit) {
      if (isFirst.value) {
        return h('div', {
          style: skeletonStyles
        });
      } else if (data.loading && !selectedComponent) {
        return h('div', {
          style: skeletonStyles
        });
      } else {
        return h(KeepAlive, {}, () => h(selectedComponent, selectedComponent == tableInnerEdit ? editParams : { editParams }));
      }
      // return '主属性字段';
    } else {
      // 不可编辑逻辑
      if (setEntity === 4 && params.fieldType === 4 && params.fieldKey === 'taxRate') {
        //产品对象的税率特殊处理
        return tools.getPercentage(params.fieldValue, 0) + '%' || '';
      } else if (params.fieldType === 4 && params.fieldKey === 'status') {
        //生命状态
        if (isFirst.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          return h(KeepAlive, {}, () =>
            h(nSelectComponent, {
              status: params.fieldValue, //生命状态
              statusOrigin: params.record['statusOrigin'], //生命状态
              rollbackRoot: params.record['rollbackRoot'] // 退回状态
            })
          );
        }
      } else if (params.fieldType === 6) {
        // 人员
        if (isFirst.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          return h(KeepAlive, {}, () =>
            h(nSelectComponent, {
              record: params.fieldValue
            })
          );
        }
      } else if (params.fieldType === 11) {
        //超链接
        return h(
          'a',
          {
            style: {
              color: 'rgb(var(--link-6))',
              cursor: 'pointer'
            },
            href: params.fieldValue,
            target: '_blank'
          },
          t('查看')
        );
      } else if (params.fieldType === 18) {
        //附件
        if (isFirst.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          return h(KeepAlive, {}, () =>
            h(lyAttachmentList, {
              fieldValue: params.fieldValue
            })
          );
        }
      } else if (params.fieldType === 12) {
        //查找关联单选
        if (isFirst.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          return h(KeepAlive, {}, () =>
            h(lyAssociation, {
              isList: true,
              value: params.fieldValue,
              entity: params.fieldExt,
              listEntity: setEntity
            })
          );
        }
      } else if (params.fieldType === 25) {
        //查找关联对选
        if (isFirst.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          return h(KeepAlive, {}, () => h(associationNonEditAble, { editParams }));
        }
      } else if (params.fieldType === 24) {
        //计算类型
        return h(KeepAlive, {}, () => h(lyComputedCmp, { params }));
      } else if (params.fieldType === 26) {
        if (isFirst.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          return h(lyRichText, {
            fieldValue: params.fieldValue
          });
        }
      } else {
        if (params.fieldType === 23 && !isNaN(parseFloat(setFieldValue))) return setFieldValue + '%';
        if (params.fieldType === 7 && !isNaN(parseFloat(setFieldValue))) {
          const getFieldExt = tools.isJSON(params.fieldExt) && JSON.parse(params.fieldExt);
          return setFieldValue + (getFieldExt?.numberUnit ? getFieldExt.numberUnit : '');
        }
        if ([2, 3, 4, 5, 10].includes(params.fieldType)) {
          return h(KeepAlive, {}, () =>
            h(lyTagFields, {
              isList: true,
              fieldValue: setFieldValue,
              styleInfo: params.fieldExt,
              fieldType: params.fieldType,
              fieldKey: params.fieldKey,
              fieldName: params.fieldName
            })
          );
        }
        if (params.mainField) {
          //主属性字段
          let spanColor = 'rgb(var(--link-6))';
          if (data.specialProduct.includes(Number(setEntity))) {
            //特殊产品显示不能点击状态
            spanColor = 'var(--td-text-color-primary)';
          }
          return h(
            'span',
            {
              style: {
                color: spanColor,
                cursor: 'pointer'
              }
            },
            params.fieldValue?.label ?? params.fieldValue?.value ?? setFieldValue ?? '-'
          );
        } else {
          return params.fieldValue?.label ?? params.fieldValue?.value ?? setFieldValue ?? '-';
        }
      }
    }
  } else {
    if (isEditTableRow && isEdit) {
      if (isFirst.value) {
        return h('div', {
          style: skeletonStyles
        });
      } else if (data.loading) {
        return h('div', {
          style: skeletonStyles
        });
      } else {
        return h(KeepAlive, {}, () => h(selectedComponent, { editParams }));
      }
    } else {
      if (params.mainField) {
        //主属性字段
        return h(
          'span',
          {
            style: {
              color: 'rgb(var(--link-6))',
              cursor: 'pointer'
            }
          },
          params.fieldValue == '' ? '-' : params.fieldValue?.label ?? params.fieldValue?.value ?? params.fieldValue ?? '-'
        );
      } else {
        if (params.fieldType === 24) {
          // 计算字段特殊处理
          return h(KeepAlive, {}, () => h(lyComputedCmp, { params }));
        }
        return params.fieldValue == '' ? '-' : params.fieldValue?.label ?? params.fieldValue?.value ?? params.fieldValue ?? '-';
      }
    }
  }
};
// 创建操作列配置
const createOperationColumn = () => ({
  colType: false,
  title: () => {
    return <span style={{ color: 'rgb(var(--gray-10))' }}> {t('操作')}</span>;
  },
  stopPropagation: true,
  colKey: 'operations',
  fixed: 'right',
  width: operationItem.value
});
// 创建选择行的列配置
const createRowSelectColumn = () => ({
  colType: false,
  colKey: 'row-select',
  fixed: 'left',
  type: 'multiple',
  width: 32,
  resizable: false,
  checkProps: ({ row }) => {
    return {
      // 计算异常禁止选择
      disabled: computingStatus.includes(row?.computedInfo?.status)
    };
  }
});
// 创建计算状态列配置
const createRowComputedColumn = () => ({
  colType: false,
  colKey: 'computed-status',
  fixed: 'left',
  align: 'right',
  className: 'computed-status',
  resizable: false,
  width: expandLevel1Icon.value ? 20 : 30
});

// 自定义操作列
const customOperationColumn = () => ({
  title: 'custom-operations-title',
  colType: false,
  colKey: 'custom-operations',
  fixed: 'left',
  width: 46,
  resizable: false,
  className: 'custom-operations'
});
// 创建列配置
const createColumnConfig = (item) => {
  const k = item.fieldKey; //字段标识
  const frozen = item.frozen; //是否为固定行
  const fieldType = item.fieldType == 21 ? item?.business?.fieldType : item?.fieldType;
  const fieldExt = item.fieldType == 21 ? item?.business?.fieldExt : item?.fieldExt;
  //可编辑的字段类型
  const isEditTableRow = !['businessId', 'entityType'].includes(item.fieldKey) && item.fieldType !== 21 && !editFieldTypeList?.includes(fieldType) && item.type != 0 && ((entity.value >= 200 && item.fieldKey != 'chargePerson') || (entity.value < 200 && !editEntityList[entity.value]?.includes(item.fieldKey))) && !contractFieldKey.includes(item.fieldKey);
  const width = item.mainField ? 250 : tools.getStrLen(item.fieldName) <= 6 ? 120 : tools.getStrLen(item.fieldName) > 10 ? 220 : tools.getStrLen(item.fieldName) * 20;
  // 表格的className属性设置单元格的类名
  const colType = {
    title: (h, { col }) => (item.fieldType == 27 ? item.fieldName : <ly-col-more col={col} record={item} fieldName={item.fieldName} findAssociation={findAssociation} ruleForm={data.ruleForm} viewId={data.viewId} colOverlayId={data.colOverlayId} showColOverlay={data.showColOverlay} getSearchDataCb={getSearchData} sortCb={sortChange} cb={colTitleFrozen} showLayCb={showLay} isSubForm={false} />),
    colKey: k,
    type: item.type,
    ellipsisTitle: { theme: 'light' },
    ellipsis: isEditTableRow || [3, 5, 12, 25].includes(fieldType) || (item.type == 0 && fieldType == 5) ? undefined : { theme: 'default' },
    id: item.id,
    stopPropagation: [12, 25].includes(fieldType) ? true : false,
    fieldName: item.fieldName,
    fieldType: fieldType,
    oldFieldType: item?.fieldType,
    fieldExt: fieldExt,
    resize: tools.getStrLen(item.fieldName) <= 5 ? { minWidth: 120 } : tools.getStrLen(item.fieldName) > 10 ? { minWidth: 300 } : { minWidth: tools.getStrLen(item.fieldName) * 30 },
    className: item.fieldType == 27 ? 'sub-form-table-border' : '',
    fixed: frozen ? 'left' : undefined
  };
  // 表格的cell函数
  const render = (h, { row }) => {
    const record = JSON.parse(JSON.stringify(row));
    const params = {
      ...item,
      fieldValue: record[k],
      fieldType: fieldType,
      oldFieldType: item?.fieldType,
      fieldExt: fieldExt,
      record: record,
      fieldInfo: item //兼容查找关联编辑，需要拼接字段的modules结构
    };
    return setRender(h, params, true);
  };
  if (item.type === 1) {
    colType.colType = t(t('基础字段'));
  }
  if (k === detailKey(entity.value) && !isEditTableRow) {
    //跳转详情的key

    colType.slotName = k;
    colType.width = 250;

    //自定义插槽
  } else if (data.slots?.indexOf(k) > -1) {
    // 2024/07/26曹建博去掉自定义插槽 slotName: k，添加render,

    colType.slotName = k;
    colType.width = 200;
  } else if (fieldType === 8 || fieldType === 9 || fieldType === 18) {
    colType.width = 200;
    colType.cell = render;
  } else {
    colType.width = width;
    colType.cell = render;
  }
  return colType;
};
// 创建子表单列配置
const createChildColumns = (item) => {
  const colTypeChildren = [];
  item?.fieldVos?.forEach((el, index) => {
    const childRender = (h, { row }) => {
      const record = JSON.parse(JSON.stringify(row));
      const subFormData = record?.[item?.fieldKey] || [];
      // 遍历子表单数据，为每个子表单记录渲染单元格
      if (subFormData?.length > 0) {
        return h('p', { class: 'child-table-container' }, [
          ...subFormData.map((subFormRecord) => {
            const params = {
              ...el,
              fieldValue: subFormRecord?.[el.fieldKey] || '', // 使用子表单中的数据
              record: subFormRecord, // 使用子表单中的数据
              subEntityId: item.fieldExt, //子表单的entityId
              isSubForm: true, //是子表
              fieldInfo: { ...el, setting: { ...el } }, //兼容查找关联编辑，需要拼接字段的modules结构
              computedInfo: record?.computedInfo ? record?.computedInfo : null
            };
            return h('p', { class: 'child-table-container-second' }, setRender(h, params, true));
          })
        ]);
      } else {
        return h('p', { class: 'child-table-temp-container' }, '-');
      }
    };

    const isEditTableRow = !editFieldTypeList?.includes(el.fieldType) && el.type != 0 && ((entity.value >= 200 && el.fieldKey != 'chargePerson') || (entity.value < 200 && !editEntityList[entity.value]?.includes(el.fieldKey))) && !contractFieldKey.includes(el.fieldKey);
    const getColType = {
      title: (h, { col }) => <ly-col-more col={col} fieldName={el.fieldName} findAssociation={findAssociation} ruleForm={data.ruleForm} viewId={data.viewId} colOverlayId={data.colOverlayId} showColOverlay={data.showColOverlay} getSearchDataCb={getSearchData} sortCb={sortChange} cb={colTitleFrozen} showLayCb={showLay} setting={item} isSubForm={true} />,
      colKey: `${item.fieldKey}.${el.fieldKey}`,
      type: el.type,
      ellipsisTitle: { theme: 'light' },
      ellipsis: isEditTableRow || [3, 5, 12, 25].includes(el.fieldType) || (item.type == 0 && el.fieldType == 5) ? undefined : { theme: 'default' },
      id: el.id,
      stopPropagation: [12, 25].includes(el.fieldType) ? true : false,
      fieldName: el.fieldName,
      fieldType: el.fieldType,
      setting: item?.fieldVos?.length ? getSubFormField(item.fieldVos) : null,
      fieldExt: el.fieldExt,
      width: tools.getStrLen(item.fieldName) <= 6 ? 180 : tools.getStrLen(item.fieldName) > 10 ? 220 : tools.getStrLen(item.fieldName) * 23,
      cell: childRender,
      className: item?.fieldVos?.length == 1 ? 'sub-form-table-list sub-form-table-border-left sub-form-table-border-right' : index == 0 ? 'sub-form-table-list sub-form-table-border-left' : index == item?.fieldVos?.length - 1 ? 'sub-form-table-list sub-form-table-border-right' : 'sub-form-table-list'
    };
    colTypeChildren.push(getColType);
  });
  return colTypeChildren;
};
// 从所有字段中获取表格头部标题
const getColumns = () => {
  const list = [];
  const fieldList = data.fieldList;
  fieldList?.forEach((item) => {
    const colConfig = createColumnConfig(item);
    if (item?.fieldType == 27) {
      //子表单
      const childCols = createChildColumns(item);
      colConfig.children = childCols;
    }
    list.push(colConfig);
  });
  // colType: false,代表不参与排序的列
  if (buttonBatch.value?.length) {
    // list.unshift(createRowSelectColumn());
  }
  if (operationItem.value) {
    list.push(createOperationColumn());
  }
  // list.unshift(createRowComputedColumn());
  console.log(createRowComputedColumn, createRowSelectColumn);
  list.unshift(customOperationColumn());

  return list;
};
const getSubFormField = (fieldVos) => {
  return fieldVos?.map((v) => {
    return {
      fieldKey: v.fieldKey,
      entityId: v.entityId,
      id: v.id,
      fieldType: v.fieldType
    };
  });
};
// 排序  sort.isDefault == true  恢复默认  sort.isNull == true  清空所有
const sortChange = async (sort = null) => {
  addFieldsSort(data.fieldList, fieldsSort.value);
  // 默认排序
  if (typeof sort === 'object' && sort !== null) {
    if (sort.isDefault == true) {
      filterParams.value.sortSettings = useFilterList?.fieldsSortDefault?.length ? useFilterList?.fieldsSortDefault : [];
    }
    if (sort.isNull == true) {
      filterParams.value.sortSettings = [];
    }
  } else {
    // 自定义排序
    filterParams.value.sortSettings = useFilterList?.fieldsSort?.length ? useFilterList?.fieldsSort : [];
  }
  // 过滤掉 停用字段
  if (filterParams.value.sortSettings && filterParams.value.sortSettings?.length) {
    filterParams.value.sortSettings = filterParams.value.sortSettings?.filter((item) => item.fieldStatus != 2);
    // 添加 sort 与 fieldSort
    filterParams.value.sortSettings = JSON.parse(JSON.stringify(filterParams.value))?.sortSettings.map((item) => {
      item.sort = item.fieldSort;
      delete item.fieldSort;
      return item;
    });
  }
  setLoadListParams(filterParams.value);
  selectTableIds.value = [];
  await loadTList(1);
};
// 标题冻结列
const colTitleFrozen = (key, value, newColumns) => {
  // 创建一个新的数组，避免直接修改原始数据
  const updatedColumns = newColumns?.map((item) => ({ ...item }));
  console.log(834, key, value, newColumns, updatedColumns, 'updatedColumns');
  // 分别筛选出左固定、右固定和非固定的列
  const fixedLeft = updatedColumns?.filter((item) => item.fixed === 'left' && item.colKey !== key);
  const fixedRight = updatedColumns?.filter((item) => item.fixed === 'right' && item.colKey !== key);
  const noFixed = updatedColumns?.filter((item) => !item.fixed && item.colKey !== key);
  // 找到当前列
  const current = updatedColumns?.find((item) => item.colKey === key);
  // 根据 value 来设置当前列的 fixed 属性
  if (value) {
    current.fixed = 'left';
    fixedLeft.push(current); // 将当前列放入左固定数组
  } else {
    current.fixed = undefined;
    noFixed.unshift(current); // 将当前列放入非固定数组的开头
  }
  // 组合新的列数组，确保顺序为左固定 -> 非固定 -> 右固定
  const newList = [...fixedLeft, ...noFixed, ...fixedRight];
  // 假设 fhTableRef.value.getCols(newList) 可以正确处理顺序问题
  fhTableRef.value.getCols(newList);
  console.log(847, newList);
};
// 遮罩层
const showLay = (val, key) => {
  console.log('点击遮罩层', val, key);
  data.showColOverlay = val;
  if (!key) return;
  data.colOverlayId = key;
};
//重置刷新列表
const resetSelected = async (v = null) => {
  ids.value = [];
  selectTableIds.value = [];
  // 判断当前页是否删除完
  if (v?.setPage && tProps.value.pagination.current > 1) {
    tProps.value.pagination.current = tProps.value.pagination.current - 1;
  }
  await loadTList();
};

// 快捷组件中按钮的回调
const shortcutBtnCb = (params) => {
  if (params?.type === 'refreshRow') {
    console.log(884, '删除单行', params);
    selectTableIds.value = selectTableIds.value.filter((v) => v !== params.id);
  }
  // 判断当前页是否删除完
  if (params?.setPage && tProps.value.pagination.current > 1) {
    tProps.value.pagination.current = tProps.value.pagination.current - 1;
  }
  refreshList();
};
// 分组的回调
const hasGroup = (params) => {
  console.log(1666, params);
  emits('cbGroup', params);
};
// 列表高度监听
watch(
  () => windowHeight.value,
  (v) => {
    console.log(1273, v);
    //如果有顶部快捷进入设置 则多减少40px
    const reduceHeight = userInfo?.roles?.indexOf(entity.value >= 200 ? 'object:custom' : 'object:system') !== -1 ? 218 : 178;
    listScroll.value = v - 300 > 200 ? v - reduceHeight : 300;
  },
  {
    deep: true,
    immediate: true
  }
);
//适配自定义对象，添加detailKey的监听zl2024年02月18日16:40:44
watch(
  () => [operationItem.value, detailKey(entity.value)],
  async () => {
    data.columns = getColumns();
  }
);

watch(
  () => data.viewId,
  () => {
    selectTableIds.value = [];
    const params = {
      viewId: data.viewId,
      filterParams: filterParams.value,
      pagination: tProps.value.pagination
    };
    scopeLimit.value = tools.getCookie(scopeKey);
    highSearch.value = scopeLimit.value ? Number(scopeLimit.value) : 0;
    emits('cb', { type: 2, params });
  },
  {
    deep: true,
    immediate: true
  }
);

watch(
  () => useFilterList?.fieldsSort,
  (v) => {
    fieldsSort.value = v;
  },
  {
    deep: true,
    immediate: true
  }
);

const eventListen = () => {
  windowHeight.value = window.innerHeight;
};
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
eventListener('resize', eventListen);

onMounted(async () => {
  // 获取筛选条件
  await useFilterList.getConditionsList({ entity: entity.value });
  data.ruleForm.conditions = useFilterList?.conditionsList;

  // 获取数据
  windowHeight.value = window.innerHeight;
  // 如果不支持筛选则传递默认参数
  //特殊情况：：： 如果是线索池需要先调用接口拿线索池ID的默认线索池id，赋值给scope
  if (!props.isFilter) {
    // entity和id必须有一个必填（id为视图ID）
    setLoadListParams({ conditions: [], entity: entity.value, scope: '0' });
    await loadTList(1);
  }

  const res = await setService.getEntitySettings({ entity: entity.value, apiIndex: Math.random() }); //查询entity所有字段
  data.ruleForm.leadsFieldList = res.result;
  data.ruleForm.leadsFieldList
    ?.filter((v) => v.fieldType !== 18 && !(v.fieldType === 21 && v.business?.fieldType === 18))
    ?.forEach((item) => {
      if (item.fieldType === 10) {
        item.fieldExt = item.fieldExt?.replace('"isEnabled":true', '"disabled":false').replace('"isEnabled":false', '"disabled":true');
      } else if (item?.business?.fieldType == 10) {
        item.business.fieldExt = item.business?.fieldExt?.replace('"isEnabled":true', '"disabled":false').replace('"isEnabled":false', '"disabled":true');
      }
      data.ruleForm.objList[item.fieldKey] = item;
    });
  try {
    const json = await setService.getDynamic({ apiIndex: Math.random() });
    if (!json.error) {
      json.result?.forEach((item) => {
        if (item.fieldType === 24) {
          data.ruleForm.filterType[item.fieldType] = item.computeMaps; //第二个框
        } else {
          data.ruleForm.filterType[item.fieldType] = item.conditions; //第二个框
        }
      });
      if (props.parentEntityId) {
        data.qccID.push(findAssociation);
      }
    }
  } catch (e) {
    console.log(e);
  }
});

provide('defaultParams', {
  id: computed(() => data.id),
  entity: computed(() => data.setEntity),
  tab: computed(() => data.tab),
  viewId: computed(() => (data?.tableLevel ? '' : data.viewId)), //兼容多层级表格
  account_id: computed(() => data.account_id),
  input_rbKcJb: computed(() => data.bingDataInput_rbKcJb),
  poolId: computed(() => poolId.value),
  columns: computed(() => data.columns),
  fieldFilterList: computed(() => fieldFilterList.value),
  dataPermission: computed(() => data.dataPermission)
});
// provide('listSort', {
//   sortChange: computed(() => sortChange),
//   addFieldsSortFun: computed(() => addFieldsSortFun)
// });
const refreshList = async (tp) => {
  if (tp === 'detail') {
    console.log(99555555556, '关闭弹窗');
    emits('cb', { type: 3 });
  } else {
    clearRowKeys();
    selectTableIds.value = [];
    expandedLevel1RowKeys.value = [];
    expandedLevel2RowKeys.value = [];
    data.loading = true;
    await loadTList();
    fhTableRef.value?.fhTableRef?.refreshTable();
    data.loading = false;
    randomKey.value++;
  }
};
// 公共按钮组件事件回调
const universalRefreshList = (tp) => {
  if (tp === 'detail') {
    getLoadTableList(undefined, false);
  } else {
    loadTList();
  }
};
const getLoadTableList = async function (a1, a2) {
  if (useLayout?.changeViewId?.[data?.entity]) {
    setLoadListParams({
      id: useLayout?.changeViewId?.[data?.entity]
    });
    data.viewId = useLayout?.changeViewId?.[data?.entity];
    selectTableIds.value = [];
    getField();
  }
  loadTList(a1, a2);
};

defineExpose({ searchInit, getField, loadTList, toDetails, getLoadTableList });
</script>
<style scoped lang="less">
@import './ly-list-layout.less';
</style>
